const getAsDate = (value:any): Date => {
    if (!value) return value;
    if (value instanceof Date) return value;
    if (typeof value === "string") {
        return new Date(value);
    }
    return undefined;
}

export default getAsDate;